import React from 'react'
import {Paper, List} from '@material-ui/core'
import TColorPicker from './TColorPicker'
import TTextAlign from './TTextAlign'
import TTextStyle from './TTextStyle'
import TFontFamily from './TFontFamily'
import TFontSize from './TFontSize'
import useStyles from './BarcodeLabelTextToolbar.styles'

function BarcodeLabelTextToolbar(props) {
  const classes = useStyles(props)
  const {values} = props

  const handleChangeFontSize = e => {
    props.onChange('font_size', e.target.value)
  }
  const handleChangeFontFamily = e => {
    props.onChange('font_family', e.target.value)
  }
  const handleChangeFontStyle = (k, v) => {
    props.onChange(k, v)
  }
  const handleChangeTextAlign = e => {
    props.onChange('text_align', e.target.value)
  }
  const handleChangeColor = e => {
    props.onChange('color', e.target.value.replace('#', ''))
  }

  return (
    <List component={Paper} className={classes.toolBar}>
      {/* Font Size */}
      <TFontSize value={values.font_size} onChange={handleChangeFontSize} />
      {/* Font Family */}
      <TFontFamily value={values.font_family} onChange={handleChangeFontFamily} />
      {/* Font Style: Bold | Italic | Underlined */}
      <TTextStyle value={values} onChange={handleChangeFontStyle} />
      {/* Text Align Option */}
      <TTextAlign value={values.text_align} onChange={handleChangeTextAlign} />
      {/* Text Align Option */}
      <TColorPicker value={values.color} onChange={handleChangeColor} />
    </List>
  )
}

export default BarcodeLabelTextToolbar
